import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { firstAccessiblePath, hasPageAccess } from "../lib/pageAccess";

const PrivateRoute = ({ userData, children, pageKey, ownerOnly }) => {
  const location = useLocation();

  if (!userData?.email) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (ownerOnly && userData.role !== "owner") {
    return <Navigate to={firstAccessiblePath(userData)} replace />;
  }

  if (pageKey && !hasPageAccess(userData, pageKey)) {
    return <Navigate to={firstAccessiblePath(userData)} replace />;
  }

  return children;
};

export default PrivateRoute;
